import { AppRoute, MenuStage, NavigationLinkBase } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

@Injectable()
export class MyApplicationsNavLink extends NavigationLinkBase {
  public readonly allowedStages = MenuStage.SIGNED_IN;

  constructor() {
    super('MY_APPLICATIONS', _('menu.label.my_applications'), AppRoute.EinreichungNew, _('a11y.link.einreichen'));
  }
}
